import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react'
import { cn } from '@/lib/cn'
import type { SortState } from './sort'
import styles from './SortableHead.module.scss'

interface SortableHeadProps<C extends string> {
  col: C
  label: string
  sort: SortState<C> | null
  onClick: (col: C) => void
  align?: 'left' | 'center' | 'right'
}

/**
 * Column header that doubles as a sort trigger — shared by the analytics
 * tables (retention audit, published videos) so both cycle and look the
 * same. Inherits font/case from the table's head row; the cycle itself is
 * ``nextSort`` in ./sort.
 */
export function SortableHead<C extends string>({ col, label, sort, onClick, align = 'left' }: SortableHeadProps<C>) {
  const isActive = sort?.col === col
  const Icon = !isActive ? ArrowUpDown : sort.dir === 'asc' ? ArrowUp : ArrowDown
  return (
    <button
      type="button"
      className={cn(
        styles.headBtn,
        align === 'right' && styles.headBtnRight,
        align === 'center' && styles.headBtnCenter,
        isActive && styles.headBtnActive,
      )}
      onClick={() => { onClick(col) }}
      aria-label={
        isActive
          ? `${label} ordenado ${sort.dir === 'asc' ? 'crescente' : 'decrescente'}; clique para ${sort.dir === 'asc' ? 'inverter' : 'remover'}`
          : `${label}; clique para ordenar`
      }
    >
      <span>{label}</span>
      <Icon className={styles.headBtnIcon} aria-hidden />
    </button>
  )
}
